import React, { useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import moment from 'moment';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios, { AxiosError } from 'axios';
import { TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseConfig from '../../config/BaseConfig';
import localePrice from '../../utilities/localePriceHelper';

type ServerError = {
  code: string;
  description: string;
};

type TableTypes = {
  // eslint-disable-next-line camelcase
  reservationNumber: string,
  facilityName: string,
  checkinDate: string,
  checkoutDate: string,
  netToBeCollectedTRY: number,
  agentCommisionTRY: number,
};

export const LatestReservations: React.FC = () => {
  const { t } = useTranslation();

  const [rows, setRows] = React.useState<Array<TableTypes>>([]);

  const getTable = async () => {
    try {
      const headers = BaseConfig.utilities.authorizedHeader();

      const apiClient = axios.create();

      const param = {
        partnerId: Number.isNaN(BaseConfig.utilities.partnerId()) ? BaseConfig.utilities.partnerIdInUserObject() : BaseConfig.utilities.partnerId(),
      };

      const response = await apiClient.post(
        BaseConfig.api.user('/api/Report/GetLastReservationList'),
        param,
        {
          headers: JSON.parse(headers),
        },
      );
      setRows(response.data.data);
    } catch (err) {
      if (err && err.response) {
        const axiosError = err as AxiosError<ServerError>;
        // eslint-disable-next-line no-console
        console.log(axiosError.response?.data);
      }
      throw err;
    }
  };

  useEffect(() => {
    getTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (

    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">{t('dashboard.resNo')}</TableCell>
            <TableCell align="right">{t('dashboard.facilityName')}</TableCell>
            <TableCell align="right">{t('dashboard.checkInDate')}</TableCell>
            <TableCell align="right">{t('dashboard.checkOutDate')}</TableCell>
            <TableCell align="right">{t('dashboard.amount')}</TableCell>
            <TableCell align="right">{t('dashboard.commission')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length !== 0 && (
            rows.map((row, index) => (
              <TableRow
                style={{ width: 10 }}
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.reservationNumber}
                </TableCell>
                <TableCell align="right">{row.facilityName}</TableCell>
                <TableCell align="right">{moment(row.checkinDate).format('DD.MM.YYYY')}</TableCell>
                <TableCell align="right">{moment(row.checkoutDate).format('DD.MM.YYYY')}</TableCell>
                <TableCell align="right">
                  {localePrice('tr', row.netToBeCollectedTRY, 'TL', 2)}
                </TableCell>
                <TableCell align="right">
                  {localePrice('tr', row.agentCommisionTRY, 'TL', 2)}
                </TableCell>
              </TableRow>
            ))
          )
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export { LatestReservations as default };
